import { inject } from "vue";
import { useListingArrayModel } from "./useListingArrayModel";
import { transformCustomerStoriesToApi } from "../utils/transformers/contentTransformers";
import type { CustomerStory } from "../types/listingModels";
import { ListingCustomerStoriesStoreKey } from "./listingStoreKeys";

export function createListingCustomerStoriesStore() {
    const arrayModel = useListingArrayModel<CustomerStory>();

    function getPublishable() {
        return transformCustomerStoriesToApi(arrayModel.model.value);
    }

    function updateAt(index: number, story: CustomerStory) {
        console.log(`[useListingCustomerStoriesStore] updateAt`, index, story);
        arrayModel.updateAt(index, story);
    }

    return {
        model: arrayModel.model,
        initial: arrayModel.initial,
        isDirty: arrayModel.isDirty,
        add: arrayModel.add,
        updateAt,
        removeAt: arrayModel.removeAt,
        reorder: arrayModel.reorder,
        markSaved: arrayModel.markSaved,
        resetAll: arrayModel.resetAll,
        getPublishable,
    };
}

export function useListingCustomerStoriesStore() {
    const store = inject(ListingCustomerStoriesStoreKey);
    if (!store) {
        throw new Error('useListingCustomerStoriesStore must be used within a component that provides ListingCustomerStoriesStoreKey');
    }
    return store;
}

